const anchorInjectionKey = Symbol("ArcoAnchor");
export { anchorInjectionKey };
